var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Arrow.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const Arrow = ({
  color = '#A2A3B7',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "6",
  height: "10",
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M6.00078 4.99922C6.00078 4.73922 5.90078 4.48922 5.71078 4.28922L2.16628 0.744716C1.77664 0.355081 1.14492 0.355081 0.755284 0.744716C0.366037 1.13396 0.365592 1.76492 0.75429 2.15471L3.59078 4.99922L0.755781 7.83422C0.366421 8.22358 0.36642 8.85486 0.755781 9.24422C1.14514 9.63358 1.77642 9.63358 2.16578 9.24422L5.71078 5.69922C5.90078 5.50922 6.00078 5.25922 6.00078 4.99922Z",
    fill: color
  })
});